import React, { Component } from 'react'
import { List } from 'immutable'
import { connect } from 'react-redux';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import { createSelector } from 'reselect';
import CardFullHeight from './../../components/cards/CardFullHeight'
import CardHalfHeight from './../../components/cards/CardHalfHeight'
import CardBasic from './../../components/cards/CardBasic'
import HousingPrefModal from '../../components/modals/housing-preferences'
import { Grid, Row, Col } from 'react-bootstrap'
import RaisedButton from 'material-ui/RaisedButton'
import { Link, browserHistory } from 'react-router'
import { paths } from '../../routes'
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton'

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';

import RoomList from '../../components/room-list'
import { getBuildingSelection, getRoomList, roomBrowseActions } from '../../../core/room-browse'
import { getConfirmedGroup, getPreferencesList, confirmedGroupActions } from '../../../core/confirmed-group'
import { getAuth } from '../../../core/auth'

const styles = {
  pcenter: {
    textAlign: 'center',
    color: '#f44336',
    fontSize: '16px'
  },
  button: {
    margin: '10 !important'
}

}

const capacityFilter = 2

export class HousingPreferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSubmitPreferencesDialog: false
    }
    this.handleSubmitPreferencesOpen = this.handleSubmitPreferencesOpen.bind(this)
    this.handleSubmitPreferencesClose = this.handleSubmitPreferencesClose.bind(this)
    this.handleSubmitPreferencesSubmit = this.handleSubmitPreferencesSubmit.bind(this)

    this.renderPreferenceList = this.renderPreferenceList.bind(this)
    this.renderRoomBrowseList = this.renderRoomBrowseList.bind(this)
    this.renderActionArea = this.renderActionArea.bind(this)
  }

  componentWillMount() {
    this.props.loadRooms(this.props.buildingSelection)
    const currentUser = this.props.currentUser
    if (currentUser.isInConfirmedGroup && currentUser.groupId) {
      this.props.loadConfirmedGroup()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.buildingSelection !== this.props.buildingSelection) {
      this.props.unloadRooms()
      this.props.loadRooms(nextProps.buildingSelection)
    }
    const currentUser = this.props.currentUser
    const nextCurrentUser = nextProps.currentUser
    if (!currentUser.isInConfirmedGroup && (nextCurrentUser.isInConfirmedGroup && nextCurrentUser.groupId)) {
      this.props.loadConfirmedGroup()
    }
  }

  componentWillUnmount() {
    this.props.unloadRooms()
    const currentUser = this.props.currentUser
    if (currentUser.isInConfirmedGroup && currentUser.groupId) {
      this.props.unloadConfirmedGroup()
    }
  }

  handleSubmitPreferencesOpen = () => {
    this.setState({openSubmitPreferencesDialog: true})
  }

  handleSubmitPreferencesClose = () => {
    this.setState({openSubmitPreferencesDialog: false})
  }

  handleSubmitPreferencesSubmit = () => {
    const confirmedGroup = this.props.confirmedGroup
    this.props.updateConfirmedGroup(confirmedGroup, {hasSubmittedPreferences: true})
    this.handleSubmitPreferencesClose()
    this.props.currentUserSubmitPreferences()
  }

  handleChange = (event, index, value) => {
    this.props.selectBuilding(value)
  }

  renderRoomBrowseList(rooms) {
    return <RoomList subHeader="ROOM BROWSE LIST" currentUser={this.props.currentUser} isPreferenceList={false} rooms={rooms} onRoomClick={this.props.updateConfirmedGroup}  preferenceAlreadyAdded={this.props.preferenceAlreadyAdded} preferenceGroupSizeMismatch={this.props.preferenceGroupSizeMismatch} confirmedGroup={this.props.confirmedGroup}/>
  }

  renderPreferenceList(preferences) {
    return <RoomList subHeader="PREFERENCES LIST" currentUser={this.props.currentUser} isPreferenceList={true} rooms={preferences} onRoomClick={this.props.updateConfirmedGroup} preferenceRankChange={this.props.preferenceRankChange} confirmedGroup={this.props.confirmedGroup}/>
  }

  renderActionArea(currentUser) {
    if (currentUser.isInConfirmedGroup && currentUser.isGroupLeader) {
      let disableLeaderActionButton = false
      if (this.props.confirmedGroup) {
        disableLeaderActionButton = this.props.confirmedGroup.hasSubmittedPreferences
      }

      const actionsSubmitPreferences = [
        <FlatButton
          label="Cancel"
          primary={true}
          onTouchTap={this.handleSubmitPreferencesClose}
        />,
        <FlatButton
          label="Submit"
          primary={true}
          onTouchTap={this.handleSubmitPreferencesSubmit}
        />,
      ]

      return  <div className="center pad-top row">
        <Col sm={6} xs={12}>
          <p style={styles.pcenter}>
              <a href="mailto:support@riteclass.com?Subject=Change%20Group%20Leader">
                  <RaisedButton className="pref-button" label="Transfer Leadership" primary={true} />
              </a>
          </p>
          <p style={styles.infoText}>
              Click button and send us an email with your new leader's email address.
          </p> <p hidden>'</p>
        </Col>
        <Col sm={6} xs={12} className="bottom-button">
          <p style={styles.pcenter}>
            <RaisedButton className="pref-button" label="Submit Preferences" secondary={true} onTouchTap={this.handleSubmitPreferencesOpen} disabled={disableLeaderActionButton}/>
            <Dialog
              title="Are you sure you want to submit your housing preferences?"
              actions={actionsSubmitPreferences}
              modal={true}
              open={this.state.openSubmitPreferencesDialog}
            >
              You can only do this once. Click Submit to confirm or Cancel to close this dialog.
            </Dialog>
          </p>
        </Col>
      </div>
    } else
    if (currentUser.isInConfirmedGroup) {
      return <div className="center pad-top">
        <Col sm={12} xs={12}>
          <p style={styles.pcenter}>Only your <b>Group Leader</b> can add housing preferences.</p>
        </Col>
      </div>
    } else
    {
      return <div className="center pad-top">
        <Col sm={12} xs={12}>
          <p style={styles.pcenter}>Please either <b>(1)</b> create a single, <b>(2)</b> create a housing group or <b>(3)</b> join a housing group.</p>

          <p style={styles.pcenter}>
          <Link to={paths.HOUSING_GROUP}>
              <RaisedButton style={styles.buttonOne} label="Get Housing" primary={true} />
          </Link>
          </p>

        </Col>
      </div>
    }
  }

  render() {
    let groupLottoNum = 'N/A'
    let lottoNumDisplayText = `Your Group Lottery #: ` + groupLottoNum
    if (this.props.confirmedGroup && this.props.confirmedGroup.groupLotteryNumber) {
      groupLottoNum = this.props.confirmedGroup.groupLotteryNumber
      lottoNumDisplayText = `Your Group Lottery #:${groupLottoNum}`
    }



    const styles = {
      customWidth: {
        width: 200,
      },

      drop: {
          paddingTop: 30
      },
      buttonOne: {
          marginRight: 15
      },
      infoText: {
          fontSize: 11
      },
      warn: {
          color: '#FF6600'
      }
    };
    const buildingNames = [
      "Bellingrath Hall",
      "Blount Hall",
      "East Village",
      "Ellett Hall",
      "Glassell Hall",
      "Parkway Hall",
      "Robb Hall",
      "Robinson Hall",
      "Spann Place Townhouses",
      "Stewart Hall",
      "Townsend Hall",
      "Trezevant Hall",
      "Voorhies Hall",
      "Voorhies-Townsend",
      "West Village",
      "White Hall",
      "Williford Hall"]
      const buildingMenuItems = buildingNames.map((buildingName) => {
        if (buildingName === "East Village") {
          return <MenuItem key={buildingName} value={buildingName} primaryText={`${buildingName} Apartments`} />
        }
        else if (buildingName === "Voorhies-Townsend") {
          return <MenuItem key={buildingName} value={"Voorhies Townsend Hall"} primaryText={buildingName} />
        }
        else {
          return <MenuItem key={buildingName} value={buildingName} primaryText={buildingName} />
        }
      })

    return (
      <div>

        <div className="subheader">
          <h4>Housing Preferences</h4>
          <HousingPrefModal />
        </div>
        <Grid>
          <Row className="show-grid">

          <p className="center-chip">
              <RaisedButton label={lottoNumDisplayText} disabled={true} />
          </p>

          <Col md={12}>
          <div className="center-text headline">
            <h4>Browse, add, rank, and submit your preferences for where you want to live next year. We recommend at least 6 preferences per group.</h4>
            <p style={styles.warn}><b>Tip:</b> To change the ordering of your housing preferences, click the ranking number you would like to change.</p>
          </div>
            <CardHalfHeight>
              <div className="header-gray center">My Preferences</div>

              <div>
                {this.props.preferences ? this.renderPreferenceList(this.props.preferences) : null}
              </div>

            </CardHalfHeight>

            {this.props.currentUser ? this.renderActionArea(this.props.currentUser) : null}



          </Col>

            <Col md={12}>
              <CardBasic>
                          <Col md={6} className="dropholderone">
                            <div className="center">
                              <div className="header-gray">Select a building to browse rooms</div>
                              <DropDownMenu
                                value={this.props.buildingSelection}
                                onChange={this.handleChange}
                                style={styles.customWidth}
                                autoWidth={false}
                              >
                                {buildingMenuItems}
                              </DropDownMenu>
                              </div>
                            </Col>

                            <Col lg={6} md={6} className="dropholdertwo">
                            <div className="center">
                            <div className="header-gray">View floor plans</div>
                            <DropDownMenu
                              value={this.props.buildingSelection}
                              onChange={this.handleChange}
                              style={styles.customWidth}
                              autoWidth={false}
                            >
                            <a href="https://www.rhodes.edu/sites/default/files/Bellingrath.pdf" target="_blank">
                            <MenuItem value={1} primaryText="Bellingrath Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/BlountUpdatedFloorPlan2017.pdf" target="_blank">
                            <MenuItem value={2} primaryText="Blount Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/East_Village_A.pdf" target="_blank">
                            <MenuItem value={3} primaryText="East Village A" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/East_Village_B.pdf" target="_blank">
                            <MenuItem value={3} primaryText="East Village B" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Robb_White_Ellett.pdf" target="_blank">
                            <MenuItem value={4} primaryText="Ellett Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Glassell.pdf" target="_blank">
                            <MenuItem value={5} primaryText="Glassell Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Parkway.pdf" target="_blank">
                            <MenuItem value={6} primaryText="Parkway Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Robb_White_Ellett.pdf" target="_blank">
                            <MenuItem value={7} primaryText="Robb Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Robinson.pdf" target="_blank">
                            <MenuItem value={8} primaryText="Robinson Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Spann.pdf" target="_blank">
                            <MenuItem value={9} primaryText="Spann Place Townhouses" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Stewart_1st_Floor.pdf" target="_blank">
                            <MenuItem value={10} primaryText="Stewart Hall 1st Floor" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Stewart_2nd_Floor.pdf" target="_blank">
                            <MenuItem value={11} primaryText="Stewart Hall 2nd Floor" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Townsend.pdf" target="_blank">
                            <MenuItem value={12} primaryText="Townsend Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Trezevant.pdf" target="_blank">
                            <MenuItem value={13} primaryText="Trezevant Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Voorhies.pdf" target="_blank">
                            <MenuItem value={14} primaryText="Voorhies Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Voto.pdf" target="_blank">
                            <MenuItem value={15} primaryText="Voorhies-Townsend" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/West_Village_Dimensions.pdf" target="_blank">
                            <MenuItem value={16} primaryText="West Village" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Robb_White_Ellett.pdf" target="_blank">
                            <MenuItem value={17} primaryText="White Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Williford_1st_Floor.pdf" target="_blank">
                            <MenuItem value={18} primaryText="Williford Hall 1st Floor" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Williford_2nd_Floor.pdf" target="_blank">
                            <MenuItem value={19} primaryText="Williford Hall 2nd Floor" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Williford_3rd_Floor.pdf" target="_blank">
                            <MenuItem value={20} primaryText="Williford Hall 3rd Floor" />
                            </a>

                            </DropDownMenu>
                            </div>
                            <div className="centertwo">
                            <div className="header-gray">View room dimensions</div>
                            <DropDownMenu
                              value={this.props.buildingSelection}
                              onChange={this.handleChange}
                              style={styles.customWidth}
                              autoWidth={false}
                            >

                            <a href="https://www.rhodes.edu/sites/default/files/Bellingrath_Dimensions.pdf" target="_blank">
                            <MenuItem value={1} primaryText="Bellingrath Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Blount_Dimensions.pdf" target="_blank">
                            <MenuItem value={2} primaryText="Blount Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/East_Village_Dimensions.pdf" target="_blank">
                            <MenuItem value={3} primaryText="East Village" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Rob_White_Ellett_Dimensions.pdf" target="_blank">
                            <MenuItem value={4} primaryText="Ellett Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Glassell_Dimensions.pdf" target="_blank">
                            <MenuItem value={5} primaryText="Glassell Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Parkway_Hall_Dimensions.pdf" target="_blank">
                            <MenuItem value={6} primaryText="Parkway Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Rob_White_Ellett_Dimensions.pdf" target="_blank">
                            <MenuItem value={7} primaryText="Robb Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Robinson_Dimensions.pdf" target="_blank">
                            <MenuItem value={8} primaryText="Robinson Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Spann_Dimensions.pdf" target="_blank">
                            <MenuItem value={9} primaryText="Spann Place Townhouses" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Stewart_Dimensions.pdf" target="_blank">
                            <MenuItem value={10} primaryText="Stewart Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Townsend_Dimensions.pdf" target="_blank">
                            <MenuItem value={11} primaryText="Townsend Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Trezevant_Dimensions.pdf" target="_blank">
                            <MenuItem value={12} primaryText="Trezevant Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Voorhies_Dimensions.pdf" target="_blank">
                            <MenuItem value={13} primaryText="Voorhies Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/VOTO_Dimensions.pdf" target="_blank">
                            <MenuItem value={14} primaryText="Voorhies-Townsend" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/West_Village.pdf" target="_blank">
                            <MenuItem value={15} primaryText="West Village" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Rob_White_Ellett_Dimensions.pdf" target="_blank">
                            <MenuItem value={16} primaryText="White Hall" />
                            </a>

                            <a href="https://www.rhodes.edu/sites/default/files/Williford_Dimensions.pdf" target="_blank">
                            <MenuItem value={17} primaryText="Williford Hall" />
                            </a>

                            </DropDownMenu>
                            </div>
                            </Col>
                            </CardBasic>
                    </Col>
                </Row>
                 <Row className="show-grid">
                <Col lg={12} md={12}>
                <Card>
                <div>
                  {this.props.rooms.first() ? this.renderRoomBrowseList(this.props.rooms) : null}
                </div>
                </Card>

            </Col>
            </Row>

        </Grid>
      </div>
    )
  }
}

const mapStateToProps = createSelector(
  getBuildingSelection,
  getRoomList,
  getConfirmedGroup,
  getPreferencesList,
  getAuth,
  (buildingSelection, rooms, confirmedGroup, preferences, currentUser) => ({
    buildingSelection,
    rooms,
    confirmedGroup,
    preferences,
    currentUser
  })
);
const mapDispatchToProps = Object.assign(
  {},
  roomBrowseActions,
  confirmedGroupActions
)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HousingPreferences)



// WEBPACK FOOTER //
// ./src/views/pages/housing-preferences/index.js